export default class AuthProviderConfigModel {
    getIdToken: any = null;
    logout: any = null;
}
